import type { FilterSortOption } from '$global/features/filter-drawer/types';

export enum TalksGallerySort {
	Newest = '-release_date',
	Oldest = 'release_date',
}

export const talksGallerySort: FilterSortOption[] = [
	{
		value: TalksGallerySort.Newest,
		dataCy: 'newest',
		label: 'Newest',
	},
	{
		value: TalksGallerySort.Oldest,
		dataCy: 'oldest',
		label: 'Oldest',
	},
];
